import { useState, useEffect, useRef } from "react";

function detectarIdiomaNavegador(idiomasDisponibles) {
  const idiomaNavegador = (
    (typeof navigator !== "undefined" &&
      (navigator.language || navigator.userLanguage)) ||
    "es"
  )
    .toLowerCase()
    .split("-")[0];

  return idiomasDisponibles.includes(idiomaNavegador) ? idiomaNavegador : "es";
}

// Resuelve el idioma activo de la web de un evento: respeta la elección
// manual del visitante (localStorage) si ya existe y sigue siendo válida;
// si no, cae al idioma del navegador si el evento lo ofrece; si no, "es".
// idiomasDisponibles puede llegar como ["es"] en el primer render (mientras
// Firebase todavía no entrega eventWebPublic.idiomas) y crecer después, por
// lo que se recalcula cuando cambia — salvo que el visitante ya haya elegido
// manualmente en esta sesión.
export default function useIdiomaEvento(eventoIndex, idiomasDisponibles) {
  const claveLocalStorage = eventoIndex
    ? `dashport_idioma_${eventoIndex}`
    : null;

  const [idioma, setIdiomaState] = useState("es");
  const eligioManualmenteRef = useRef(false);

  useEffect(() => {
    if (eligioManualmenteRef.current) return;

    const guardado =
      claveLocalStorage && typeof localStorage !== "undefined"
        ? localStorage.getItem(claveLocalStorage)
        : null;

    if (guardado && idiomasDisponibles.includes(guardado)) {
      setIdiomaState(guardado);
      return;
    }

    setIdiomaState(detectarIdiomaNavegador(idiomasDisponibles));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claveLocalStorage, JSON.stringify(idiomasDisponibles)]);

  function setIdioma(nuevoIdioma) {
    eligioManualmenteRef.current = true;
    setIdiomaState(nuevoIdioma);
    if (claveLocalStorage && typeof localStorage !== "undefined") {
      localStorage.setItem(claveLocalStorage, nuevoIdioma);
    }
  }

  return [idioma, setIdioma];
}
